import {
  CurrencyDollarSimple,
  Lifebuoy,
  Binoculars,
  Quotes,
  Buildings,
} from "@phosphor-icons/react";
import classNames from "classnames";
import * as React from "react";
import styles from "../Navbar.module.css";
import chromeIcon from "~/assets/Chrome-icon.svg";
import { ReadMoreLink } from "~/components/DesignSystem/ReadMoreLink";

export interface MobileResourcesContentProps {
  chromeExtensionUrl?: string;
}

export const MobileResourcesContent: React.FC<MobileResourcesContentProps> = ({
  chromeExtensionUrl,
}) => {
  const chromeHref = chromeExtensionUrl || "/chrome-extension";

  return (
    <div className={styles.mobileDropdownContent}>
      <a href="/resources/roi" className={styles.mobileDropdownItem}>
        <div className={`${styles.productIcon} ${styles.roiIcon}`}>
          <CurrencyDollarSimple size={19} weight="fill" />
        </div>
        <div className={styles.mobileDropdownItemText}>
          <span className={styles.mobileDropdownItemTitle}>ROI</span>
          <span className={styles.mobileDropdownItemDescription}>
            See how Vendr delivers measurable savings and ROI for companies of
            all sizes
          </span>
        </div>
      </a>

      <a
        href="/resources/supplier-coverage"
        className={styles.mobileDropdownItem}
      >
        <div className={`${styles.productIcon} ${styles.supplierCoverageIcon}`}>
          <Buildings size={19} weight="fill" />
        </div>
        <div className={styles.mobileDropdownItemText}>
          <span className={styles.mobileDropdownItemTitle}>
            Supplier Coverage
          </span>
          <span className={styles.mobileDropdownItemDescription}>
            Discover which SaaS vendors and software suppliers are covered by
            Vendr
          </span>
        </div>
      </a>

      <div
        className={classNames(
          styles.mobileDropdownItem,
          styles.mobileDropdownItemDisabled,
        )}
      >
        <div className={`${styles.productIcon} ${styles.blogIcon}`}>
          <Quotes size={19} weight="fill" />
        </div>
        <div className={styles.mobileDropdownItemText}>
          <span className={styles.mobileDropdownItemTitle}>Blog</span>
          <span className={styles.mobileDropdownItemDescription}>
            Read the latest insights, tips, and best practices for procurement
            and negotiations
          </span>
        </div>
      </div>

      <div
        className={classNames(
          styles.mobileDropdownItem,
          styles.mobileDropdownItemDisabled,
        )}
      >
        <div className={`${styles.productIcon} ${styles.trendsIcon}`}>
          <Binoculars size={19} weight="fill" />
        </div>
        <div className={styles.mobileDropdownItemText}>
          <span className={styles.mobileDropdownItemTitle}>Trends Reports</span>
          <span className={styles.mobileDropdownItemDescription}>
            Access comprehensive market trends and pricing reports to inform
            your strategy
          </span>
        </div>
      </div>

      <div
        className={classNames(
          styles.mobileDropdownItem,
          styles.mobileDropdownItemDisabled,
        )}
      >
        <div
          className={`${styles.productIcon} ${styles.resourceCenterItemIcon}`}
        >
          <Lifebuoy size={19} weight="fill" />
        </div>
        <div className={styles.mobileDropdownItemText}>
          <span className={styles.mobileDropdownItemTitle}>
            Resource Center
          </span>
          <span className={styles.mobileDropdownItemDescription}>
            Learn how modern, intelligent procurement works
          </span>
        </div>
      </div>

      {/* Chrome Extension Card - Featured */}
      <a
        href={chromeHref}
        target={chromeExtensionUrl ? "_blank" : undefined}
        rel={chromeExtensionUrl ? "noopener noreferrer" : undefined}
        className={styles.chromeCard}
      >
        <div className={styles.chromeCardContent}>
          <div className={styles.chromeCardText}>
            <span className={styles.chromeCardLabel}>Browser Extension</span>
            <span className={styles.chromeCardTitle}>
              Pricing intel,
              <br />
              everywhere you go
            </span>
          </div>
          <div className={styles.chromeCardVisual}>
            <img src={chromeIcon} alt="" className={styles.chromeCardIcon} />
          </div>
        </div>
        <div className={styles.chromeCardFooter}>
          <ReadMoreLink href={chromeHref} as="span">
            Add to Chrome
          </ReadMoreLink>
        </div>
      </a>
    </div>
  );
};
